import React from 'react';
import { Link } from 'react-router-dom';
import { buttonClass } from './settings/SettingsUI';
import { LockIcon } from './icons/LucideIcons';

// Settings → Plan (audit P2 #17); billing slice B3 turns it into Plan & billing.
export const PLAN_SETTINGS_PATH = '/settings?tab=plan';

/**
 * Shown in place of a screen or settings tab the shop's plan does not include
 * (billing slice B4), so the feature stays discoverable instead of vanishing.
 * Edges and a surface ladder, no opacity fades (docs/design-system.md).
 */
const AddToPlanCard = ({ title, body, icon = null }) => (
  <div className="card empty-state mx-auto w-full max-w-[640px] px-6 py-8" data-testid="add-to-plan">
    <span className="empty-state-icon">
      {icon || <LockIcon size={20} />}
    </span>
    <h2 className="empty-state-title">{title}</h2>
    {body && <p className="empty-state-text max-w-[52ch]">{body}</p>}
    <Link to={PLAN_SETTINGS_PATH} className={`${buttonClass.primary} mt-2`}>Add to your plan</Link>
  </div>
);

export default AddToPlanCard;
